import styles from './Table.module.scss'
import TableBody from './tableBody/TableBody'
import TableHead from './tableHead/TableHead'
import { AppData } from '../../../types/appData'

interface Props {
  appData: AppData[]
  setAppData: (appData: AppData[]) => void
  setSortNameOrder: (sortNameOrder: 'ASC' | 'DESC') => void
  sortNameOrder: 'ASC' | 'DESC'
  setSortCategoryOrder: (sortCategoryOrder: 'ASC' | 'DESC') => void
  sortCategoryOrder: 'ASC' | 'DESC'
}

const Table = ({
  appData,
  setAppData,
  setSortNameOrder,
  sortNameOrder,
  setSortCategoryOrder,
  sortCategoryOrder,
}: Props) => {
  return (
    <table className={styles.table}>
      <TableHead
        appData={appData}
        setAppData={setAppData}
        setSortNameOrder={setSortNameOrder}
        sortNameOrder={sortNameOrder}
        setSortCategoryOrder={setSortCategoryOrder}
        sortCategoryOrder={sortCategoryOrder}
      />
      <TableBody appData={appData} />
    </table>
  )
}

export default Table
